import { render, staticRenderFns } from "./RaCardInfo.vue?vue&type=template&id=594ae370&scoped=true&"
import script from "./RaCardInfo.vue?vue&type=script&lang=js&"
export * from "./RaCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./RaCardInfo.vue?vue&type=style&index=0&id=594ae370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594ae370",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
